import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://api.boltin.com';
// Backend routes are under /api/till-sessions
const TILL_SESSIONS_API_PATH = '/api/till-sessions';

const openTillSession = async (tillId, openingFloat, openingDenominations) => {
  const response = await axios.post(`${API_BASE_URL}${TILL_SESSIONS_API_PATH}/open`, { tillId, openingFloat, openingDenominations });
  return response.data.data;
};

const closeTillSession = async (tillId, closingFloat, closingDenominations, leaveAmount, closingNote) => {
  const response = await axios.post(`${API_BASE_URL}${TILL_SESSIONS_API_PATH}/close`, {
    tillId,
    closingFloat,
    closingDenominations,
    leaveAmount,
    closingNote,
  });
  return response.data.data;
};

const getOpenSession = async (tillId) => {
  const response = await axios.get(`${API_BASE_URL}${TILL_SESSIONS_API_PATH}/open`, { params: { tillId } });
  return response.data;
};

const tillService = {
  openTillSession,
  closeTillSession,
  getOpenSession,
};

export default tillService;
